module.exports = __webpack_public_path__ + "img/address-title-success.380c6c8c.png";